import LoadingSpinner from "@/components/loading/LoadingSpinner"
import { SystemRole } from "@/models"
import { useLoggedInUser } from "@/stores/coreDataStore"
import { onMounted, type FunctionalComponent } from "vue"
import { useRouter } from "vue-router"
import { defineComponent } from "vue-utils"

const RootRedirectView: FunctionalComponent = () => {
	const user = useLoggedInUser()
	const router = useRouter()

	onMounted(async () => {
		if (user.atLeastHasRole(SystemRole.CoastguardReadOnly)) {
			await router.push("/incident-map")
		} else {
			await router.push("/vts-logs/list")
		}
	})

	return () => (
		<div class="flex h-full items-center justify-center">
			<LoadingSpinner />
		</div>
	)
}

export default defineComponent(RootRedirectView)
